import React from 'react'
import Table from './Table'
import general from '../../helpers/general'

export default function Categories({ Auth, deleteCategories, data, updateCategory, clone }) {
	const columns = [
		{
			field: 'name',
			access: 'name',
		},
		{
			field: 'isAvailable',
			render: function ({ row, column, index }) {
				;<p>Is Available</p>
			},
		},
		general?.checkPermissions({
			exceptPermissions: ['category'],
			originalPermissions: Auth?.user?.permissions,
		}) && {
			field: 'Actions',
			render: ({ row }) => (
				<div className={`actionsWrapper`}>
					<>
						{!row?.fromParent && (
							<i onClick={() => updateCategory(row)} className={`edit-icon fal fa-edit`} />
						)}
						<i onClick={() => clone(row)} className={`edit-icon fal fa-copy`} />
						{!row?.fromParent && (
							<i
								onClick={() => {
									if (row?._id) {
										deleteCategories([row?._id], row?.name)
										return
									}
									deleteCategories(row)
								}}
								className={`delete-icon far fa-trash-alt`}
							/>
						)}
					</>
				</div>
			),
		},
	]
	return (
		<Table
			columns={columns}
			rows={data || []}
			enableLocalPagination={true}
			enableSelectMultiple={true}
			onDeleteMultiple={(ids) => deleteCategories(ids)}
		/>
	)
}
